export default __webpack_public_path__ + "static/media/IMG_0430-2.c81d71b5.jpg";